import React from 'react';
import { useTranslation } from 'react-i18next';

/* Props: { referrerName } */
const ReferralHero = ({ referrerName }) => {
  const { t } = useTranslation();
  return (
    <section className="text-center space-y-2">
      <h1 className="text-3xl font-bold text-foreground">
        {referrerName
          ? t('referral.landing.headlinePersonal', { name: referrerName })
          : t('referral.landing.headline')}
      </h1>
      <p className="text-muted-foreground">{t('referral.landing.subheadline')}</p>
    </section>
  );
};

export default ReferralHero;
